export default "__VITE_ASSET__b8706195__"